export const DS_BRIEF_BASE_URL = '/design/briefs';
export const DS_BRIEF_CREATE_URL = '/design/briefs/create';
export const DS_REQUEST_BRIEF_CREATE_URL = '/design/request/new';
export const DS_BRIEF_MULTI_STEP_URL = '/experts/request/brief';
